import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { MazeGameCoreService } from './maze-game-core.service';
import { MazeGameSelectorComponent } from './maze-game-selector/maze-game-selector.component';

@NgModule({
  declarations: [MazeGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [MazeGameCoreService],
  exports: [MazeGameSelectorComponent],
})
export class MazeGameCoreModule {}
